<template>
  <va-edit-layout>
    <role-form :id="id" :title="title" :item="item"></role-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
